import React from "react";
import { inject, observer } from "mobx-react";
import Header from "../../sharedComponents/header/header";
import { CalculateStore } from "../../../stores/calculateStore";
import Address from "../../sharedComponents/address/address";

interface EstateDataProps {
  calculateStore?: CalculateStore;
}

@inject("calculateStore")
@observer
export default class EstateData extends React.Component<EstateDataProps> {
  public render() {
    return (
      <div className="section estate-data">
        <Header type="medium" mainHeader="Adres ubezpieczanej nieruchomości" />
        <Address address={this.props.calculateStore!.estate.address}
          disabled={true}
          displayLabel={true} />
      </div>
    );
  }
}
